const ionic = require('ionic')

module.exports = ['$q', '$location', '$http', '$utils', '$rootScope', '$cookies', 'LocalStorage',
  function ($q, $location, $http, $utils, $rootScope, $cookies, LocalStorage) {
    function WmsvrClient() {
    }

    WmsvrClient.prototype.defer = $q
    WmsvrClient.prototype.platform = ionic.Platform
    WmsvrClient.prototype.location = $location
    WmsvrClient.prototype.http = $http
    WmsvrClient.prototype.htmlUtils = $utils.$html

    WmsvrClient.prototype.simpleCall = function (options) {
      const self = this
      options = options || {}
      const { interceptor, method, headers, timeout } = options
      options.interceptor = typeof interceptor === 'boolean' ? interceptor : true
      options.method = method || 'POST'
      options.headers = headers || {}
      options.headers.Accept = options.headers.Accept || 'text/x-json'
      options.transformResponse = function (data, headersGetter) {
        return data
      }
      options.headers['Content-Type'] = options.headers.hasOwnProperty('Content-Type') ? options.headers['Content-Type'] : 'text/x-json'
      options.url = self.getRequestURL(options)
      options.headers['X-CM-SERVICE'] = 'PHONE'
      options.timeout = timeout || $rootScope.settings.xhrTimeout || 30000

      const deferred = self.defer.defer()
      self.http(options).success(function (data, status, headers, config) {
        data = JSON.parse(data || '')
        if (data['code'] == 'S_OK' || data['code'] == 'S_PARTIAL_OK') {
          deferred.resolve(data)
        } else {
          const reason = {
            data,
            status,
            headers,
            config
          }
          deferred.reject(reason)
        }
      }).error(function (data, status, headers, config) {
        const reason = {
          data,
          status,
          headers,
          config
        }
        if (status == 504) {
          $rootScope.badNetwork = true
        } else {
          $rootScope.badNetwork = false
        }
        deferred.reject(reason)
      })

      return deferred.promise
    }

    WmsvrClient.prototype.getWmsvrURLPrefix = function () {
      let port = $location.port()
      port = (port !== 80 && port !== 443) ? ':' + port : ''
      let coremailUrl = LocalStorage.getItem('coremailurl')
      if (typeof coremailUrl !== 'string' || coremailUrl.indexOf('http') !== 0) {
        coremailUrl = null
      }
      return coremailUrl || ($location.protocol() + '://' + $location.host() + port + '/coremail')
    }

    /**
     * 构造请求路径
     * @param {object} query 查询参数
     * @param {string} url 绝对地址
     * @param {string} path 相对 WmsvrURLPrefix 的地址
     * @returns {string} 完整请求地址
    */
    WmsvrClient.prototype.getRequestURL = function ({query, url, path}) {
      let urlPrefix = this.getWmsvrURLPrefix()
      urlPrefix = urlPrefix.slice(-1) === '/' ? urlPrefix.slice(0, -1) : urlPrefix
      query = query || {}
      path = path || '/s/'

      let requestUrl = url || `${urlPrefix}${path}`
      let queryStr = ''
      for (const name in query) {
        if (query[name]) {
          queryStr += `${name}=${query[name]}&`
        }
      }
      requestUrl += queryStr ? `?${queryStr.slice(0, -1)}` : ''
      return requestUrl
    }

    return WmsvrClient
  }
]



// WEBPACK FOOTER //
// ./src/js/infrastructure/WmsvrClient.js